import React from 'react';
import type { FormikValues } from 'formik';
import { useFormikContext } from 'formik';
import { get } from 'lodash';

import FieldConfigurationCard from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/FieldConfigurationCard/FieldConfigurationCard';
import BaseConfigurationSection from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/Sections/BaseConfigurationSection';
import ConfiguredFieldsSection from '~/components/SystemConfiguration/FnolConfiguration/FnolConfigurationScreen/Sections/ConfiguredFieldsSection';

const ID_PREFIX = 'configuration.policy.covered_vehicle';
const VEHICLE_ID_PREFIX = `${ID_PREFIX}.vehicle`;

const CoveredVehicleSection: React.FC = () => {
  const { values } = useFormikContext<FormikValues>();
  const coveredVehicleFields = get(values, VEHICLE_ID_PREFIX, {});
  const coveredVehicleFieldsKeys = Object.keys(coveredVehicleFields);

  return (
    <BaseConfigurationSection title="Covered Vehicle" subtitle="Key: covered_vehicle" isSection noGridContainer>
      {coveredVehicleFieldsKeys.map((fieldId) => (
        <FieldConfigurationCard key={fieldId} fieldId={fieldId} idPrefix={VEHICLE_ID_PREFIX} />
      ))}
      <ConfiguredFieldsSection
        fieldId={`${ID_PREFIX}.configured_fields`}
        disabled={false}
        disableCategories
        withDndReorder
      />
    </BaseConfigurationSection>
  );
};

export default CoveredVehicleSection;
